import { APITypesV1 } from "@cur8/api-client";
import { useMutation } from "@tanstack/react-query";
import { useAPIClient } from "render/context/APIContext";

type Variables = {
  patientId: string;
  drawnBloodSampleIds: string[];
  skippedBloodSamples: {
    bloodSampleId: string;
    reason: APITypesV1.SkipReason;
  }[];
};

// No onError here by design — DrawConfirmationView surfaces the error inline
// and keeps the local decisions intact so Done can just be retried.
export function useConfirmDrawMutation() {
  const api = useAPIClient();

  return useMutation({
    mutationFn({
      patientId,
      drawnBloodSampleIds,
      skippedBloodSamples,
    }: Variables) {
      return api.bloodSample.confirmDraw(
        { patientId },
        { drawnBloodSampleIds, skippedBloodSamples }
      ).result;
    },
  });
}
